<template>
    <v-container>
        <v-card>
            <v-tabs>
                <v-tab href="#salary" @click="getPayList('salary')">{{text.payColmun.salary}}</v-tab>
                <v-tab href="#bonus" @click="getPayList('bonus')" v-if="bounusFlag">{{text.payColmun.bonus}}</v-tab>
                <v-tab href="#yend" @click="getPayList('yend')">{{text.payColmun.yend}}</v-tab>
                <v-tab href="#salaryResign" @click="getResing('salary')" v-if="resignFlag">{{text.payColmun.resignation}}</v-tab>
                <v-tab-item value="salary">
                    <v-select :no-data-text="text.noSelectData" :items="salary.period" v-model="salary.periodSet" @change="selectPeriod('salary')"></v-select>
                    <v-btn @click="printPdf('salary')">{{text.print}}</v-btn>
                    <div v-for="itemA in salary.viewItems" :key="itemA.title" style="border-style:solid;border-width:thin;background-color:#F5F5F5;">
                        <v-card-title class="py-0" style="white-space: nowrap">{{itemA.title}}</v-card-title>
                        <v-container>
                            <v-row dense>
                                <v-col :class="itemB._class" v-for="itemB in itemA.cards" :key="itemB.title">
                                    <v-card :outlined="degien.cardLine" :color="degien.cardColor" class="pd-0" v-if="!itemB.children">
                                        <v-card-subtitle class="ma-0 pa-0 text-subtitle-2" style="text-align: center;white-space:none">{{itemB.title}}</v-card-subtitle>
                                        <v-card-text class="ma-0 pa-0" style="text-align: end;font-size:1.5rem">{{itemB.value}}</v-card-text>
                                    </v-card>
                                    <v-card :outlined="degien.cardLine" :color="degien.subCardColor" v-if="itemB.children">
                                        <v-card-title class="py-0" style="white-space: nowrap">{{itemB.title}}</v-card-title>
                                        <v-container>
                                            <v-row dense>
                                                <v-col class="pd-0" v-for="itemC in itemB.children" :key="itemC.title">
                                                <v-card :outlined="degien.cardLine" :color="degien.cardColor" class="pd-0">
                                                <v-card-subtitle class="ma-0 pa-0 text-subtitle-2" style="text-align: center;white-space:none">{{itemC.title}}</v-card-subtitle>
                                                <v-card-text class="ma-0 pa-0" style="text-align: end;font-size:1.5rem">{{itemC.value}}</v-card-text>
                                                </v-card>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </div>
                </v-tab-item>
                <v-tab-item value="bonus" v-if="bounusFlag">
                    <v-select :no-data-text="text.noSelectData" :items="bounus.period" v-model="bounus.periodSet" @change="selectPeriod('bonus')"></v-select>
                    <v-btn @click="printPdf('bonus')">{{text.print}}</v-btn>
                    <div v-for="itemA in bounus.viewItems" :key="itemA.title" style="border-style:solid;border-width:thin;background-color:#F5F5F5;">
                        <v-subheader style="white-space: nowrap">{{itemA.title}}</v-subheader>
                        <v-container>
                            <v-row dense>
                                <v-col v-for="itemB in itemA.cards" :key="itemB.title" :cols="itemA._childrenCols">
                                    <v-card :outlined="degien.cardLine" :color="degien.cardColor" class="pd-0" v-if="!itemB.children" style="min-width:120px">
                                        <v-card-text class="ma-0 pa-0 text-subtitle-2" style="text-align: center;white-space:none">{{itemB.title}}</v-card-text>
                                        <v-card-text class="ma-0 pa-0" style="text-align: end;font-size:1.5rem">{{itemB.value}}</v-card-text>
                                    </v-card>
                                    <v-card :outlined="degien.cardLine" :color="degien.subCardColor" v-if="itemB.children">
                                        <v-card-title class="text-subtitle-2">{{itemB.title}}</v-card-title>
                                        <v-card-text>
                                            <v-row dense>
                                                <v-col v-for="itemC in itemB.children" :key="itemC.title">
                                                <v-card :outlined="degien.cardLine" :color="degien.cardColor" class="pd-0" style="min-width:120px">
                                                <v-card-text class="ma-0 pa-0 text-subtitle-2" style="text-align: center;white-space:none">{{itemC.title}}</v-card-text>
                                                <v-card-text class="ma-0 pa-0" style="text-align: end;font-size:1.5rem">{{itemC.value}}</v-card-text>
                                                </v-card>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </div>
                </v-tab-item>
                <v-tab-item value="yend">
                    <v-select :no-data-text="text.noSelectData" :items="yend.period" v-model="yend.periodSet" @change="selectPeriod('yend')"></v-select>
                    <v-tabs v-show="yend.periodSet !== null">
                        <v-tab href="#yendAdj">{{text.yendAdj}}</v-tab>
                        <v-tab href="#withholdingTax">{{text.withholdingTax}}</v-tab>
                        <v-tab-item value="yendAdj">
                            <v-btn @click="printPdf('yend')">{{text.print}}</v-btn>
                            <div v-for="itemA in yend.viewItems" :key="itemA.title" style="border-style:solid;border-width:thin;background-color:#F5F5F5;">
                                <v-subheader>{{itemA.title}}</v-subheader>
                                <v-container>
                                    <v-row dense>
                                        <v-col v-for="itemB in itemA.cards" :key="itemB.title" :cols="itemA._childrenCols">
                                            <v-card :outlined="degien.cardLine" :color="degien.cardColor" class="pd-0" v-if="!itemB.children" style="min-width:120px">
                                                <v-card-text class="ma-0 pa-0 text-subtitle-2" style="text-align:center;white-space:none">{{itemB.title}}</v-card-text>
                                                <v-card-text class="ma-0 pa-0" style="text-align: end;font-size:1.5rem">{{itemB.value}}</v-card-text>
                                            </v-card>
                                            <v-card :outlined="degien.cardLine" :color="degien.subCardColor" v-if="itemB.children">
                                                <v-card-title class="text-subtitle-2">{{itemB.title}}</v-card-title>
                                                <v-card-text>
                                                    <v-row dense>
                                                        <v-col v-for="itemC in itemB.children" :key="itemC.title">
                                                        <v-card :outlined="degien.cardLine" :color="degien.cardColor" class="pd-0" style="min-width:120px">
                                                        <v-card-text class="ma-0 pa-0 text-subtitle-2" style="text-align: center;white-space:none">{{itemC.title}}</v-card-text>
                                                        <v-card-text class="ma-0 pa-0" style="text-align: end;font-size:1.5rem">{{itemC.value}}</v-card-text>
                                                        </v-card>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </div>
                        </v-tab-item>
                        <v-tab-item value="withholdingTax">
                            <v-btn @click="printPdf('tax')">{{text.print}}</v-btn>
                            <div v-show="false" v-for="itemA in yend.viewItemsTax" :key="itemA.title" style="border-style:solid;border-width:thin;background-color:#F5F5F5;">
                                <v-subheader>{{itemA.title}}</v-subheader>
                                <v-container>
                                    <v-row dense>
                                        <v-col v-for="itemB in itemA.cards" :key="itemB.title" :cols="itemA._childrenCols">
                                            <v-card :outlined="degien.cardLine" :color="degien.cardColor" v-if="!itemB.children" style="min-width:120px">
                                                <v-card-text class="ma-0 pa-0 text-subtitle-2" style="text-align: center;white-space:none">{{itemB.title}}</v-card-text>
                                                <v-card-text class="ma-0 pa-0" style="text-align: end;font-size:1.5rem">{{itemB.value}}</v-card-text>
                                            </v-card>
                                            <v-card :outlined="degien.cardLine" :color="degien.subCardColor" v-if="itemB.children">
                                                <v-card-title class="text-subtitle-2">{{itemB.title}}</v-card-title>
                                                <v-card-text>
                                                    <v-row dense>
                                                        <v-col v-for="itemC in itemB.children" :key="itemC.title">
                                                        <v-card :outlined="degien.cardLine" :color="degien.cardColor" style="min-width:120px">
                                                        <v-card-text class="ma-0 pa-0 text-subtitle-2" style="text-align: center;white-space:none">{{itemC.title}}</v-card-text>
                                                        <v-card-text class="ma-0 pa-0" style="text-align: end;font-size:1.5rem">{{itemC.value}}</v-card-text>
                                                        </v-card>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </div>
                        </v-tab-item>
                    </v-tabs>
                </v-tab-item>
                <v-tab-item value="salaryResign" v-if="resignFlag">
                    <SalaryResign ref="refSalaryResign" @eMounted="moutedSalaryResign" />
                </v-tab-item>
            </v-tabs>
        </v-card>
    </v-container>
</template>

<script lang="ts">
    import Vue from 'vue';
    import lang from "../lang";
    let text = new lang(0);
    import exceljs from "exceljs";
    import fileSaver from "file-saver";
    import SalaryResign from "./resignation/index.vue";
    import {apiRequest} from "../lib/api";
    import {PayInfo,ViewDeginDetail,Defitems} from "../lib/api/api_response_type";
    import * as comm from '../common';
    import * as type from '../types';
    import {getAddDef} from '../addsDef';

    const taxViewComponent = {} as type.component;

    let onKeyE = false;
    const chekEggKey = (keyEvent:KeyboardEvent) => {
        onKeyE = (keyEvent.altKey && keyEvent.ctrlKey);
    }
    window.addEventListener("keydown",(e=>{
        chekEggKey(e);
    }));
    window.addEventListener("keyup",(e=>{
        chekEggKey(e);
    }));
    const getOnKeyE = () => {return onKeyE}

    interface vueSalaryResign extends Vue{
        updateInfo:(type:number,dataInfo:unknown)=>void;
    }

    export default Vue.extend({
        components:{
            SalaryResign,
        },
        data: () => ({
            text : text.Text,
            degien:{
                cardLine:false,
                cardColor:"blue-grey lighten-4",
                subCardColor:"blue-grey lighten-3",
            },
            userData:{} as type.userData,
            salary:{
                period:[] as Array<{value:any,text:string,_sortKey:number,_objKey:string}>,
                periodSet : 0,
                payData:[] as Array<PayInfo>,
                defs:{} as {[key:string]:string},
                viewItems:[] as Array<type.viewDeginDetail>,
                viewDegin:null as Array<ViewDeginDetail>|null,
                viewItemsTax:[] as Array<type.viewDeginDetail>,
                viewDeginTax:null as Array<ViewDeginDetail>|null,
                person:[] as Array<type.personInfo>,
                fm:[] as Array<type.res_family>,
                act:{} as {[key:string]:string},
            },
            bounus:{
                period:[] as Array<{value:any,text:string,_sortKey:number,_objKey:string}>,
                periodSet : 0,
                payData:[] as Array<PayInfo>,
                defs:{} as {[key:string]:string},
                viewItems:[] as Array<type.viewDeginDetail>,
                viewDegin:null as Array<ViewDeginDetail>|null,
                viewItemsTax:[] as Array<type.viewDeginDetail>,
                viewDeginTax:null as Array<ViewDeginDetail>|null,
                //person:[] as Array<type.personInfo>,
                fm:[] as Array<type.res_family>,
                act:{} as {[key:string]:string},
            },
            bounusFlag:false,
            yend:{
                period:[] as Array<{value:any,text:string,_sortKey:number,_objKey:string}>,
                periodSet : null as number|null,
                payData:[] as Array<PayInfo>,
                defs:{} as {[key:string]:string},
                viewItems:[] as Array<type.viewDeginDetail>,
                viewDegin:null as Array<ViewDeginDetail>|null,
                viewItemsTax:[] as Array<type.viewDeginDetail>,
                viewDeginTax:null as Array<ViewDeginDetail>|null,
                person:[] as Array<type.personInfo>,
                fm:[] as Array<type.res_family>,
                act:{} as {[key:string]:string},
            },
            resignFlag:false,
            cEvents:{
                resign:{
                    component:undefined as undefined|vueSalaryResign,
                    flag:false,
                    type:0,
                    data:{} as unknown,
                },
            },
            api:null as null|{connection:boolean,apiRequest:null|apiRequest},
        }),
        mounted() {
            this.api = this.$store.state.apiSaver;
        },
        methods:{
            reset(){
                //@ts-ignore
                Object.assign(this.$data,this.$options.data());
            },
            parentCallback(order:string){
                switch(order){
                    case "pageShow":{
                        this.getPayList("salary");
                        this.userData = this.$store.state.user;
                        const tp = this.userData.tpdata;
                        this.bounusFlag = tp.BounusCount>0?true:false; //(tp.BonusFlag0|tp.BonusFlag1|tp.BonusFlag2|tp.BonusFlag3)===0?false:true;
                        this.resignFlag = this.userData.flags.salaryResign;
                    }
                    break;
                    case "reset":
                        this.reset();
                    break;
                }
            },
            selectPeriod(type:"salary"|"bonus"|"yend"){
                const _target = type==="salary"?this.salary:type==="bonus"?this.bounus:type==="yend"?this.yend:null;
                if(_target && _target.periodSet !== null){
                    _target.viewItems = [];
                    if(_target.viewDegin){
                        const _ = this.cvDegieData(_target.viewDegin,_target.payData[_target.periodSet].defItems);
                        //@ts-ignore
                        _target.viewItems = this.cvDegieData(_target.viewDegin,_target.payData[_target.periodSet].defItems);
                    }
                    if(type === "yend"){
                        if(_target.viewDeginTax){
                            const __ = this.cvDegieData(_target.viewDeginTax,_target.payData[_target.periodSet].defItems);
                            //_target.viewItemsTax = this.cvDegieData(_target.viewDeginTax,_target.payData[_target.periodSet].defItems);
                        }
                        _target.act = {};
                        _target.act = Object.assign(_target.act,_target.payData[_target.periodSet].defItems);
                        //_target.act = Object.assign(_target.act,_target.person);
                        _target.act = Object.assign(_target.act,{_fm:_target.fm});
                        _target.act = Object.assign(_target.act,{_year:(new Date(_target.payData[_target.periodSet].atDate)).getFullYear()});
                    }
                }
            },
            async getPayList(type:"salary"|"bonus"|"yend"){
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    if(type === "salary"){
                        const apiResponse = await this.api.apiRequest.request.my.getSalary();
                        comm.LoadingOverlay(this,false);
                        if(apiResponse.statusCode === 200){
                            const payRes = apiResponse.data;
                            if(!payRes.viewData){
                                comm.ApiErrorMessege(this,comm.unknowError);
                                return;
                            }
                            const typeOrder = this.salary;
                            if(!typeOrder){
                                return false;
                            }
                            typeOrder.viewDegin = payRes.viewData||null;
                            typeOrder.period = [];
                            typeOrder.payData = [];
                            for(const [k,v] of Object.entries(payRes.list)){
                                const ym = k.split("-");
                                typeOrder.period.push({
                                    "text":comm.strReplacePercentObject(this.text.payColmun.salaryPeriodText,{"Y":ym[0],"M":ym[1]}),
                                    "value":typeOrder.period.length,
                                    "_sortKey":parseInt(`${ym[0]}${ym[1].length===1?"0":""}${ym[1]}`,10),
                                    "_objKey":k,
                                });
                                typeOrder.payData.push(v);
                            }
                            typeOrder.period.sort((a,b)=>{
                                return b._sortKey - a._sortKey;
                            });
                            if(typeOrder.period.length > 0){
                                typeOrder.periodSet = typeOrder.period[0].value;
                                this.selectPeriod(type);
                            }
                        }else if(apiResponse.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError);
                        }
                    }
                    if(type === "bonus"){
                        const apiResponse = await this.api.apiRequest.request.my.getBonus();
                        comm.LoadingOverlay(this,false);
                        if(apiResponse.statusCode === 200){
                            const payRes = apiResponse.data;
                            if(!payRes.viewData){
                                comm.ApiErrorMessege(this,comm.unknowError);
                                return;
                            }
                            const typeOrder = this.bounus;
                            if(!typeOrder){
                                return false;
                            }
                            typeOrder.viewDegin = payRes.viewData;
                            typeOrder.period = [];
                            typeOrder.payData = [];
                            for(const [k,v] of Object.entries(payRes.list)){
                                const ym = k.split("-");
                                typeOrder.period.push({
                                    "text":comm.strReplacePercentObject(this.text.payColmun.bonusPeriodText,{"Y":ym[0],"S":this.text.bonusNoStr[parseInt(ym[1],10)]}),
                                    "value":typeOrder.period.length,
                                    "_sortKey":parseInt(`${ym[0]}${ym[1].length===1?"0":""}${ym[1]}`,10),
                                    "_objKey":k,
                                });
                                typeOrder.payData.push(v);
                            }
                            typeOrder.period.sort((a,b)=>{
                                return b._sortKey - a._sortKey;
                            });
                            if(typeOrder.period.length > 0){
                                typeOrder.periodSet = typeOrder.period[0].value;
                                this.selectPeriod(type);
                            }
                        }else if(apiResponse.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError);
                        }
                    }
                    if(type === "yend"){
                        const apiResponse = await this.api.apiRequest.request.my.getYend();
                        comm.LoadingOverlay(this,false);
                        if(apiResponse.statusCode === 200){
                            const payRes = apiResponse.data;
                            if(!payRes.viewData || !payRes.viewDataTax){
                                comm.ApiErrorMessege(this,comm.unknowError);
                                return;
                            }
                            const typeOrder = this.yend;
                            if(!typeOrder){
                                return false;
                            }
                            //typeOrder.person = payRes.personInfo;
                            typeOrder.viewDegin = payRes.viewData;
                            typeOrder.viewDeginTax = payRes.viewDataTax;
                            typeOrder.period = [];
                            typeOrder.payData = [];
                            for(const [k,v] of Object.entries(payRes.list)){
                                typeOrder.period.push({
                                    "text":comm.strReplacePercentObject(this.text.payColmun.yendPeriodText,{"Y":k}),
                                    "value":typeOrder.period.length,
                                    "_sortKey":parseInt(k,10),
                                    "_objKey":k,
                                });
                                typeOrder.payData.push(v);
                            }
                            typeOrder.period.sort((a,b)=>{
                                return b._sortKey - a._sortKey;
                            });
                            if(typeOrder.period.length > 0){
                                typeOrder.periodSet = typeOrder.period[0].value;
                                this.selectPeriod(type);
                            }
                        }else if(apiResponse.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError);
                        }
                    }
                }
            },
            cvDegieData(degein:Array<ViewDeginDetail>,valueItems:Defitems){
                const defaultCols = {"XS":8,"SM":6,"MD":4,"LG":2,"XL":1};
                const classStyle = ["col-%XS ","col-sm-%SM ","col-md-%MD ","col-lg-%LG ","col-lg-%XL "];
                for(const [k,v] of Object.entries(degein)){
                    for(const [kC,vC] of Object.entries(v.cards)){
                        vC._childrenCols = 1;
                        vC.value = "**error**[card defname undefined]";
                        if(vC.children){
                            vC.value = "Parent item.";
                            vC._childrenCols = vC.children.length>12?12:vC.children.length;
                            for(const [cc,cv] of Object.entries(vC.children)){
                                //@ts-ignore
                                cv.value = comm.defCalculator(cv,valueItems);
                                if(typeof cv.value === "undefined" || cv.value === null){
                                    cv.value = 0;
                                }
                                if(typeof cv.value === "number"){
                                    cv.value = comm.addCuma(cv.value);
                                }
                            }
                        }else if(typeof vC.itemCode !== "undefined"){
                            //@ts-ignore
                            vC.value = comm.defCalculator(vC,valueItems);
                            if(typeof vC.value === "undefined" || vC.value === null){
                                vC.value = 0;
                            }
                            if(typeof vC.value === "number"){
                                vC.value = comm.addCuma(vC.value);
                            }
                        }
                        const cols = {...defaultCols} as {[key:string]:number};
                        for(const colK in cols){
                            const tCols = cols[colK] * vC._childrenCols;
                            cols[colK] = tCols>12?12:tCols;
                        }
                        vC._class = classStyle.map(classData=>{
                            return comm.strReplacePercentObject(classData,cols)
                        })
                    }
                }
                degein.sort((a,b)=>{
                    if(!a.order || !b.order){return 0;}
                    if(a.order<b.order){return -1}
                    if(a.order>b.order){return 1}
                    return 0;
                });
                for(const rootItem of degein){
                    rootItem.cards.sort((a,b)=>{
                        if(!a.order || !b.order){return 0;}
                        if(a.order<b.order){return -1}
                        if(a.order>b.order){return 1}
                        return 0;
                    });
                }
                for(const rootItem of degein){
                    for(const card of rootItem.cards){
                        if(card.children){
                            card.children.sort((a,b)=>{
                                if(!a.order || !b.order){return 0;}
                                if(a.order<b.order){return -1}
                                if(a.order>b.order){return 1}
                                return 0;
                            });
                        }
                    }
                }
                return degein as unknown as type.viewDeginDetail;
            },
            updateResing(type:number,dataInfo:unknown){
                if(this.cEvents.resign.component){
                    this.cEvents.resign.component.updateInfo(type,dataInfo);
                }
            },
            moutedSalaryResign(e:any){
                const resingComp = this.$refs.refSalaryResign as vueSalaryResign;
                if(typeof this.cEvents.resign.component?.updateInfo !== "function"){
                    this.cEvents.resign.component = resingComp;
                    if(this.cEvents.resign.flag){
                        this.cEvents.resign.flag = false;
                        this.updateResing(this.cEvents.resign.type,this.cEvents.resign.data);
                    }
                }
            },
            async getResing(type:'salary'){
                if(type === "salary"){
                    comm.LoadingOverlay(this,false);
                    if(this.api && this.api.connection && this.api.apiRequest){
                        const apiResponse = await this.api.apiRequest.request.my.getResinSalary();
                        this.updateResing(apiResponse.data.format,apiResponse.data.defItem);
                    }
                }
            },
            showWth(){
                setTimeout(()=>{
                    taxViewComponent.vue = this.$refs.wht as type.vueAdd;
                    taxViewComponent.vue?.parentCallback("dataSet",this.yend.act);
                },100);
            },
            async printPdf(type:"salary"|"bonus"|"yend"|"tax"){
                if(this.api && this.api.connection && this.api.apiRequest){
                    if(type === "salary"){
                        const period = this.salary.period.find(v=>v.value===this.salary.periodSet);
                        if(!period){
                            return;
                        }
                        if(!getOnKeyE()){
                            const apiResponse = await this.api.apiRequest.request.my.printSalary(period._objKey);
                            if(apiResponse.statusCode === 200 && apiResponse.data.pdfdata){
                                    comm.openPdfNewWindow(apiResponse.data.pdfdata.data)
                            }else if(apiResponse.statusCode === 401){
                                comm.invalidSession(this);
                            }else{
                                comm.ApiErrorMessege(this,comm.unknowError);
                            }
                        }else{
                            console.log('eEgg:Export excel(xlsx).');
                            let defNames = {} as {[key:string]:string};
                            for(const _ of getAddDef(this.text)){
                                defNames[_.value] = _.text;
                            }
                            if(this.salary.defs){
                                defNames = Object.assign(defNames,this.salary.defs);
                            }
                            const headers = [] as Array<string>;
                            const data = [] as Array<string|number>;
                            for(const [key,val] of Object.entries(this.salary.payData[this.salary.periodSet].defItems)){
                                headers.push(defNames[key]??"");
                                data.push((val?val:"") as string);
                            }
                            this.exportExcelSave(headers,data);
                        }
                    }
                    if(type === "bonus"){
                        const period = this.bounus.period.find(v=>v.value===this.bounus.periodSet);
                        if(!period){
                            return;
                        }
                        const apiResponse = await this.api.apiRequest.request.my.printBonus(period._objKey);
                        if(apiResponse.statusCode === 200 && apiResponse.data.pdfdata){
                            comm.openPdfNewWindow(apiResponse.data.pdfdata.data)
                        }else if(apiResponse.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError);
                        }
                    }
                    if(type === "yend"){
                        const period = this.yend.period.find(v=>v.value===this.yend.periodSet);
                        if(!period){
                            return;
                        }
                        const apiResponse = await this.api.apiRequest.request.my.printYendAdj(period._objKey);
                        if(apiResponse.statusCode === 200 && apiResponse.data.pdfdata){
                            comm.openPdfNewWindow(apiResponse.data.pdfdata.data)
                        }else if(apiResponse.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError);
                        }
                    }
                    if(type === "tax"){
                        const period = this.yend.period.find(v=>v.value===this.yend.periodSet);
                        if(!period){
                            return;
                        }
                        const apiResponse = await this.api.apiRequest.request.my.printYendTax(period._objKey);
                        if(apiResponse.statusCode === 200 && apiResponse.data.pdfdata){
                            comm.openPdfNewWindow(apiResponse.data.pdfdata.data)
                        }else if(apiResponse.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError);
                        }
                    }
                }
            },
            async exportExcelSave(heder:Array<string>,data:Array<string|number>){
                const workBook = new exceljs.Workbook();
                const sheet = workBook.addWorksheet();
                comm.exceljsUtils.setRow(sheet,{row:1,column:1},heder);
                let row = 2;
                comm.exceljsUtils.setRow(sheet,{"row":row,"column":1},data);
                const _wbBuffer = await workBook.xlsx.writeBuffer();
                fileSaver.saveAs(new Blob([_wbBuffer]),"out.xlsx");
            },
        }
    });
</script>